import React, { useEffect, useState } from "react";
import { getLogs, getUsers, createUser, deleteUser, updateUser, updatePassword, changePin, unlockUser } from "../utils/auth";

export default function AdminDashboard({ user, onLogout }) {
  const [users, setUsers] = useState([]);
  const [editingUser, setEditingUser] = useState(null);
  const [form, setForm] = useState({ username: "", namn: "", password: "", role: "user", pin: "" });
  const [fel, setFel] = useState("");
  const [meddelande, setMeddelande] = useState("");
  const [logs, setLogs] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showCreateForm, setShowCreateForm] = useState(false);

  const fetchUsers = () => setUsers(getUsers());

  const fetchLogs = async () => {
    const logData = await getLogs();
    setLogs(logData);
  };

  useEffect(() => {
    fetchUsers();
    fetchLogs();
  }, []);

  const resetForm = () => {
    setEditingUser(null);
    setForm({ username: "", namn: "", password: "", role: "user", pin: "" });
    setFel("");
    setMeddelande("");
    setShowCreateForm(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingUser) {
        updateUser(editingUser.id, {
          username: form.username,
          namn: form.namn,
          role: form.role
        });
        if (form.password) {
          await updatePassword(editingUser.id, form.password);
        }
        if (form.pin) {
          await changePin(editingUser.id, form.pin);
        }
        setMeddelande("Användare uppdaterad.");
      } else {
        await createUser(form.username, form.password, form.role, form.namn, form.pin);
        setMeddelande("Ny användare skapad.");
      }
      fetchUsers();
      resetForm();
      fetchLogs();
    } catch (err) {
      setFel(err.message);
    }
  };

  const handleEdit = (user) => {
    setEditingUser(user);
    setForm({ username: user.username, namn: user.namn, password: "", role: user.role, pin: "" });
    setFel("");
    setMeddelande("");
    setShowCreateForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Är du säker på att du vill ta bort denna användare?")) {
      await deleteUser(id);
      fetchUsers();
      fetchLogs();
    }
  };

  const handleUnlock = async (id) => {
    await unlockUser(id);
    fetchUsers();
    fetchLogs();
  };

  const filteredLogs = logs.filter(log =>
    log.message.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const getLogColor = (type) => {
    switch (type) {
      case "success": return "#d4edda";
      case "error": return "#f8d7da";
      case "info": return "#d1ecf1";
      default: return "#fff";
    }
  };

  return (
    <div className="app-wrapper">
      <h2>Adminpanel</h2>
      <button onClick={onLogout}>Logga ut</button>

      <h3>Användare</h3>
      <button onClick={() => setShowCreateForm(!showCreateForm)}>
        {showCreateForm ? "Dölj formulär" : "Lägg till användare"}
      </button>

      {showCreateForm && (
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Användarnamn"
            value={form.username}
            onChange={e => setForm({ ...form, username: e.target.value })}
            required
          />
          <input
            type="text"
            placeholder="Namn"
            value={form.namn}
            onChange={e => setForm({ ...form, namn: e.target.value })}
            required
          />
          <input
            type="password"
            placeholder="Lösenord"
            value={form.password}
            onChange={e => setForm({ ...form, password: e.target.value })}
            required={!editingUser}
          />
          <input
            type="text"
            placeholder="4-siffrig Pinkod"
            value={form.pin}
            onChange={e => setForm({ ...form, pin: e.target.value })}
            maxLength={4}
          />
          <select
            value={form.role}
            onChange={e => setForm({ ...form, role: e.target.value })}
          >
            <option value="user">Användare</option>
            <option value="admin">Admin</option>
          </select>
          <button type="submit">{editingUser ? "Spara ändringar" : "Lägg till"}</button>
          <button type="button" onClick={resetForm}>Ångra</button>
        </form>
      )}

      <ul>
        {users.map(u => (
          <li key={u.id}>
            {u.username} ({u.role})
            <button onClick={() => handleEdit(u)}>Redigera</button>
            <button onClick={() => handleDelete(u.id)}>Ta bort</button>
            {u.locked && <button onClick={() => handleUnlock(u.id)}>Lås upp</button>}
          </li>
        ))}
      </ul>

      <h3>Loggar</h3>
      <input
        type="text"
        placeholder="Sök i loggar..."
        value={searchTerm}
        onChange={e => setSearchTerm(e.target.value)}
      />
      <div style={{ maxHeight: "300px", overflowY: "auto", marginTop: "1em" }}>
        {filteredLogs.map((log, i) => (
          <div key={i} style={{
            backgroundColor: getLogColor(log.type),
            padding: "6px",
            marginBottom: "4px",
            borderRadius: "6px"
          }}>
            <strong>{new Date(log.date).toLocaleString()}</strong> - {log.message}
          </div>
        ))}
      </div>
    </div>
  );
}
